import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { fmtZMW, fmtDate } from "@/lib/helpers";
import { DetailShell, InfoRow, InfoGrid } from "@/components/DetailShell";
import { Empty } from "@/components/primitives";
import { toast } from "sonner";

export default function FuelLogDetail() {
  const { id } = useParams();
  const [row, setRow] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/fuel-logs/${id}`);
        setRow(data);
      } catch (e) { toast.error(formatError(e)); }
      finally { setLoading(false); }
    })();
  }, [id]);

  if (loading) return <div className="phizo-label">Loading fuel log…</div>;
  if (!row) return <Empty label="Fuel log not found." />;

  return (
    <DetailShell
      overline="FUEL & DIESEL / LOG"
      title={`${row.truck_plate || "—"} · ${fmtDate(row.log_date)}`}
      subtitle={`${row.fuel_type || "diesel"} · ${row.litres} L`}
      backTo="/fuel-logs"
      testId="fuel-detail"
    >
      <InfoGrid cols={3}>
        <InfoRow label="Truck Plate" value={row.truck_plate} testId="fuel-detail-plate" />
        <InfoRow label="Log Date" value={fmtDate(row.log_date)} />
        <InfoRow label="Fuel Type" value={row.fuel_type || "diesel"} />
        <InfoRow label="Litres" value={`${row.litres} L`} />
        <InfoRow label="Cost" value={fmtZMW(row.cost_zmw)} />
        <InfoRow label="Odometer" value={row.odometer_km != null ? `${Number(row.odometer_km).toLocaleString()} km` : "—"} />
        <InfoRow label="Driver" value={row.driver || "—"} />
        <InfoRow label="Station" value={row.station || "—"} />
        <InfoRow label="Project" value={row.project_code || "—"} />
        <InfoRow label="Logged By" value={row.logged_by_name} />
      </InfoGrid>

      {row.notes && (
        <div className="mt-6 phizo-card p-4">
          <div className="phizo-label mb-2">Notes</div>
          <p className="text-sm whitespace-pre-wrap">{row.notes}</p>
        </div>
      )}
    </DetailShell>
  );
}
